export const getPriceLists = (state, priceLists) => {
  state.priceLists = priceLists
}
